export class text{
  public static lang: string = 'ru';

  private static textDictionary: Array<Array<string>> = [
    //[key, language, textvalue]
    ['copy', 'en', 'Copy'],
    ['copy', 'ru', 'Копировать'],
    ['delete', 'en', 'Delete'],
    ['delete', 'ru', 'Удалить'],
    ['deleted', 'en', 'Deleted'],
    ['deleted', 'ru', 'Удалён'],
    ['save', 'en', 'Save'],
    ['save', 'ru', 'Сохранить'],
    ['saved', 'en', 'Saved'],
    ['saved', 'ru', 'Сохранено'],
    ['cancel', 'en', 'Сancel'],
    ['cancel', 'ru', 'Отмена'],
    ['close', 'en', 'Close'],
    ['close', 'ru', 'Закрыть'],
    ['Create', 'en', 'Create'],
    ['Create', 'ru', 'Создать'],    
    ['Add snippet', 'en', 'Add snippet'],
    ['Add snippet', 'ru', 'Новый сниппет'],
    ['placeholder Search', 'en', 'Search'],
    ['placeholder Search', 'ru', 'Поиск'],
    ['placeholder Paste Code', 'en', 'Paste Code'],
    ['placeholder Paste Code', 'ru', 'Вставить'],
    ['placeholder Description', 'en', 'Description, tags, keywords ... anything'],
    ['placeholder Description', 'ru', 'Описание, тэги, ключевики ... любой текст'],
    ['newSnippetDeleteAfter option no', 'en', 'no'],
    ['newSnippetDeleteAfter option no', 'ru', 'нет'],
    ['newSnippetDeleteAfter option if not used 3 month', 'en', 'if not used 3 month'],
    ['newSnippetDeleteAfter option if not used 3 month', 'ru', 'не использовался 3 месяца'],
    ['newSnippetSave Save snippet', 'en', 'Save snippet'],
    ['newSnippetSave Save snippet', 'ru', 'Сохранить сниппет'],
    ['newSnippetSaveCancel Close', 'en', 'Close'],
    ['newSnippetSaveCancel Close', 'ru', 'Закрыть'],
    ['placeholder replace slash', 'en', 'invert slash \\ to /, / to \\'],
    ['placeholder replace slash', 'ru', 'инвертировать slash \\ в /, / в \\'],
    ['Auto-delete', 'en', 'Auto-delete'],
    ['Auto-delete', 'ru', 'Авто-удаление'],
    ['placeholder file name from path', 'en', 'file name from path'],
    ['placeholder file name from path', 'ru', 'имя файла из пути'],
    ['Can not parse snippets config text to array', 'en', 'Can not parse snippets config text to array'],
    ['Can not parse snippets config text to array', 'ru', 'Не удалось распарсить конфиг'],
    ['settings Code config', 'en', 'Code section config'],
    ['settings Code config', 'ru', 'Трансформации - Подстановки'],
    ['settings Snippets config', 'en', 'Snippets - Groups'],
    ['settings Snippets config', 'ru', 'Раздел Snippets - Группы'],
    ['settings New Snippets group name', 'en', 'New snippets group name'],
    ['settings New Snippets group name', 'ru', 'Имя новой группы сниппетов'],
    ['login', 'en', 'Login'],
    ['login', 'ru', 'Логин'],
    ['password', 'en', 'Password'],
    ['password', 'ru', 'Пароль'],
    ['login button', 'en', 'Log In'],
    ['login button', 'ru', 'Войти'],
    ['loginResultMessageDefault', 'en', 'Wrong login or password or user blocked'],
    ['loginResultMessageDefault', 'ru', 'Неверный логин или пароль или пользователь заблокирован'],
    ['Server error', 'en', 'Server error'],
    ['Server error', 'ru', 'Произошла ошибка при обращении к серверу. Обновите страницу. '],
    // ['', 'en', ''],
  ];

  /**
   * Get localized text
   * @param key 
   * @returns text value
   */
  public static of(key: string){
    let foundItem = this.textDictionary.find(
      (t) => t[0].toLowerCase()===key.toLowerCase()
                && t[1]===this.lang);
    return foundItem ? foundItem[2] : key+' не найден';
  }
}
